export default __webpack_public_path__ + "static/media/O.6d14840f.wav";